import { queryKeys } from '../queryKeys';

import { fetchMostWatched } from './fetchMostWatched';

type CreateMostWatchedQueryOptionsArgs = {
  userId: string;
};

export function createMostWatchedQueryOptions({ userId }: CreateMostWatchedQueryOptionsArgs) {
  return {
    queryKey: queryKeys.mostWatched,
    queryFn: () => fetchMostWatched(userId),
    staleTime: Infinity,
  };
}
